import { ITlfActionSetTlfCommentPanel, TlfContextProps } from "./interface";

/**
 * Replaces the TLF comment-panel state.
 *
 * @param state - Current TLF context state.
 * @param action - Set-comment-panel action containing the next panel status.
 * @returns Updated state with the comment panel status replaced.
 */
export const tlf_setTlfCommentPanel = (
  state: TlfContextProps,
  action: ITlfActionSetTlfCommentPanel,
): TlfContextProps => ({
  ...state,
  commentPanelStatus: action.commentPanelStatus,
});
